import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tCase'
})
export class TCasePipe implements PipeTransform {
  transform(value: string) {
    let strLow = value.toLowerCase();
    let strSplit = strLow.split(' ');
    for (let i = 0; i < strSplit.length; i++) {
      strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1);
    }
    return strSplit.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/t-case.ts